import { Col, Row } from 'reactstrap';
import { isDesktop } from './AppUtils.js';
import { invokeService, extractImageParts } from '../components/Utils.js';
import { uploadFile, deleteFile } from './FileUtils.js';
import Const from '../components/Const';
import { invokeServer } from './SharePostUtils';
import { getAivideoInfoIcon, getRetryAivideoIcon, getUploadImageIckon, getToAIIckon } from './PostButtonsAndIcons.js';
import { remainingChars} from '../components/Utils.js';
import { generateVideoThumbnail } from './ThumbnailUtils';
import { getNumericSafeAreaInsetsValues } from './CssUtils.js';

export function postsAndFollowersClassNames(containerName) {
  // consierge / consierge-desktop for browsing AI image is set not here.
  // consierge-desktop is set in ProfileOfLoginUser.getClassNameProfileBlock()
  // consiergeis set in ProfileOfLoginUser.getClassNameContainer().
  // "nav-display-desktop" is set in UniversalSearch.getNavOrSearchBoxOnTop()

  let isDesktopCond = isDesktop();
  let classNames = {
      postsDiv : isDesktopCond ? 'post-div-desktop' : 'post-div',
      postsDivProfile : isDesktopCond ? 'post-div-profile-desktop' : 'post-div-profile',
      rightDiv : isDesktopCond ? 'right-div-desktop' : 'right-div',
      rightDivProfile : isDesktopCond ? 'right-div-profile-desktop' : 'right-div-profile',
      scroll : isDesktopCond ? 'scroll-desktop' : 'scroll',
      afterAppWrapCenterDiv : isDesktopCond ? containerName + '-desktop' : containerName,
      bodyFullscreen3 : isDesktopCond ? 'body-fullscreen-3-desktop' : 'body-fullscreen-3',
      sugested : isDesktopCond ? 'suggested-desktop': 'suggested',
      username : isDesktopCond ? 'username-desktop': 'username',
      tagline : isDesktopCond ? 'tagline-desktop': 'tagline',
      iFollow : isDesktopCond ? 'ifollow-desktop': 'ifollow',
      loginBackground : isDesktopCond ? 'login-background-desktop': 'login-background'
    }

	return classNames;
}

export function getBottomBarMobil(charCounter, that) {
  return ( 
    <Row className="media1 row-margin-01" > 			 
      <Col className="p-0" lg={3} md={4} sm={4} xs={7}>
        <Row className="p-0">
          <Col className="flex p-0" md={3} sm={3} xs={3}>
            {
              getUploadImageIckon(that)
            }
          </Col>
          <Col className="flex p-0" md={3} sm={3} xs={3}>
            {
              getToAIIckon(that)
            }
          </Col>
          <Col className="flex p-0" md={3} sm={3} xs={3}>
            {
              that.state.retryAIvideo &&
              getAivideoInfoIcon(that)
            }
          </Col>
          <Col className="flex p-0" md={3} sm={3} xs={3}>
            {
              that.state.retryAIvideo &&
              getRetryAivideoIcon(that)
            }
          </Col>
        </Row>
      </Col>
      <Col className="p-0" lg={9} md={8} sm={8} xs={5}>           
        {
          remainingChars(charCounter)
        }
      </Col>				
    </Row> 
  ) 
}

export async function storeUserPostInDB(todayNumber, that) {
  let videoPreviewUrl = that.ImageUploadder.current.state.videoPreviewUrl; 
  let response;

  if (videoPreviewUrl) {
    that.currentVideoFile = { ...that.ImageUploadder.current.state.file };
    response = await storeVideoPostInDB(todayNumber, that);
  }
  else  {
    response = await storeRegularPostInDB(todayNumber, that);
  }
  return response.result;
}

export async function storeRegularPostInDB(todayNumber, that) {
  let imagePreviewUrl = that.ImageUploadder.current.state.imagePreviewUrl; 
  let imageParts;
  let imageType;
  let imageBody;
  let value = that.state.value;
  let data = {
      mode : Const.STORE_USER_POST_MODE,
      post : (value.length <= that.MAX_LENGTH) ? value : value.substring(0, that.MAX_LENGTH),
      number_date : todayNumber,
      
  };
  let response;

  if (imagePreviewUrl) {
      imageParts = extractImageParts(imagePreviewUrl);
      imageType = imageParts.image_type;
      imageBody = imageParts.image_body;
      //
      data.image_type = imageType;
      data.image_width = Math.ceil(that.ImageUploadder.current.imageParams.maxWidth);
      data.image_height = Math.ceil(that.ImageUploadder.current.imageParams.maxHeight);
      data.image = imageBody;
  }
  response = await invokeService(Const.OCA_SERVICES_URL, data, that);
  if (response.result) {
    response.result.data = data; // this is just to provide acess to this post image height and width 
  }
  return response;
}

export async function storeVideoPostInDB(todayNumber, that) {
  let value = that.state.value;
  let postData = {
        mode : Const.STORE_USER_POST_MODE,
        post : (value.length <= that.MAX_LENGTH) ? value : value.substring(0, that.MAX_LENGTH),
        number_date : todayNumber,
        video : true,
        image_width : that.ImageUploadder.current.state.file.width,
        image_height : that.ImageUploadder.current.state.file.height
      };
  let videoValidateData;
  let videoFile = that.ImageUploadder.current.state.file;
  let presignedUploadVideoUrl;
  let presignedDeleteVideoUrl;
  let realVideoUrl = Const.USER_VIDEO_URL + that.state.loginUser.userName + '/' + todayNumber;
  let thumbnail;
  let imageParts;
  let response;

  for (let k = 0; k < 1; k++) { // one iteration loop
    response = await getVideoS3url(todayNumber, that);
    if (that.state.serviceStatusCode !== Const.OK) {
      break;
    }
    presignedUploadVideoUrl = response.result.upload_signed_url;
    presignedDeleteVideoUrl = response.result.delete_signed_url;
    response = await uploadFile(presignedUploadVideoUrl, videoFile, that);
    if (that.state.serviceStatusCode !== Const.OK) {
      break;
    }
    if ((videoFile.type === 'video/mp4') && !videoFile.hasOwnProperty("createdByAI")) {
      videoValidateData = {
                            videoType : videoFile.type,
                            videoUrl : realVideoUrl
                          };
      response = await invokeServer(Const.VPS_SERVER_URL_VALIDATE_CODEC, videoValidateData, that); 
      if (that.state.serviceStatusCode !== Const.OK) {
        if (presignedDeleteVideoUrl) {
          await deleteFile(presignedDeleteVideoUrl, that, false);
        }
        break;
      }
    }
    thumbnail = await generateVideoThumbnail(that.ImageUploadder.current.state.videoPreviewUrl);
    imageParts = extractImageParts(thumbnail);
    postData.image_type = imageParts.image_type;
    postData.image = imageParts.image_body;
    response = await invokeService(Const.OCA_SERVICES_URL, postData, that);
  }
  return response;
}

export async function getVideoS3url(todayNumber, that) {
  let videoFile = that.ImageUploadder.current.state.file;
  let data = {
      mode : Const.GET_PRESIGN_URL,
      number_date : todayNumber,
      file_type : videoFile.type // "video/mp4"
  };
  let response = await invokeService(Const.OCA_SERVICES_URL, data, that);
     
  return response;
}

export async function getVideoSettings(that) {
  //"You have 3 complimentary attempts to re-generate this video within an hour."
  let data = { message: ''}; // we don't need any parameter
  let videoSettings = null;
  let response;

  response = await invokeServer(Const.VPS_SERVER_URL_GET_VIDEO_SETTINGS, data, that); 
  if (that.state.serviceStatusCode === Const.OK) {
    videoSettings = response.result;
  }
  return videoSettings;
}

export function getPostMediaDescriptor(post) {
  let width;
  let height;
  let koeff;
  let navHeight = 55; 
  let followersHeight = 110; 
  let savePadding = 8;
  let deviceOrientation 
  let mediaOrienation= (post.imgHeight > post.imgWidth) ? 'vertical' : 'horizontal';
  let postMediadescriptor;
  let phoneMedia = window.matchMedia(Const.PHONE_MEDIA_INTERVAL);
  let insets = getNumericSafeAreaInsetsValues();

  if (window.innerWidth > window.innerHeight) {
    deviceOrientation = 'landscape';
    if (mediaOrienation === 'vertical') {
      height = Const.POST_IMG_MAX_HEIGHT_PORTRAIT;
      koeff = post.imgWidth / post.imgHeight;
      width = height * koeff;
    }
    else {
      width = Const.POST_IMG_MAX_WIDTH_LENDSCAPE_SMALL;
      koeff = post.imgHeight / post.imgWidth;
      height = width * koeff;
    }
  }
  else {
    deviceOrientation = 'portrait';
    width = window.innerWidth;
    koeff = post.imgHeight / post.imgWidth;
    height = width * koeff;
    if (mediaOrienation === 'vertical') {
      if (height > window.innerHeight - navHeight - followersHeight - insets.safeAreaTop + insets.safeAreaBottom - savePadding) {
        // img or video takes to much space verically on a portrait device
        // we need to show a 100% of it on one screen
        if (phoneMedia.matches) {
           height = window.innerHeight - navHeight - followersHeight - insets.safeAreaTop + insets.safeAreaBottom - savePadding;
        }
        else {
           height = Const.POST_IMG_MAX_WIDTH_LENDSCAPE;
        }
        koeff = post.imgWidth / post.imgHeight;
        width = height * koeff;
      }
    }
  }
  postMediadescriptor = {
    deviceOrientation :  deviceOrientation,
    mediaOrienation : mediaOrienation,
    mediaHeight: height,
    mediaWidth: width,
    koeff: koeff
  }
  return postMediadescriptor;
}

export function getPostMediaStyle(post) {
  let postMediadescriptor = getPostMediaDescriptor(post);
  let styleObj = {
    height: postMediadescriptor.mediaHeight,
    minHeight : postMediadescriptor.mediaHeight,
    width : postMediadescriptor.mediaWidth
  } 
  return styleObj;
}

export function getPostNoMediaStyle() {
  let fakePost = { 
    imgHeight : Const.POST_IMG_MAX_WIDTH_LENDSCAPE,
    imgWidth : Const.POST_IMG_MAX_WIDTH_LENDSCAPE
  };
  let postMediadescriptor = getPostMediaDescriptor(fakePost);
  let styleObj = {
    width : postMediadescriptor.mediaWidth
  } 
  return styleObj;
}

export function addIndexToVideoPosts(posts) {
  let videoIndex = 0;

  posts.forEach(post => {
    if (post.postVideo) {
      post.videoIndex = videoIndex++;
    }
  });
}